import { Injectable } from '@angular/core';
import { CanMatch, Router } from '@angular/router';
import { AuthStore } from '@store';

import { combineLatest, Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Injectable()
export class InstallationDetailsViewGuardService implements CanMatch {
  constructor(private authStore: AuthStore, private router: Router) {}

  canMatch(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    return combineLatest([
      this.authStore.isAuthorized$,
      this.authStore.isAuthorizing$,
      this.authStore.isAuthenticating$,
    ]).pipe(
      filter(([isAuthorized, isAuthorizing]) => {
        return isAuthorized || isAuthorizing === false;
      }),
      switchMap(([isAuthorized, isAuthorizing, isAuthenticating]) => {
        const notAuthorized = !isAuthorized && !isAuthorizing && !isAuthenticating;

        if (notAuthorized) {
          this.router.navigate(['/home']);

          return of(false);
        } else {
          return this.authStore.selectDashboardFeatureIfAvailable$;
        }
      })
    );
  }
}
